import {call, put, takeEvery, takeLatest} from "redux-saga/effects";
import {Customer} from "../../../Models/Customer";
import {afterAction, fillItems, loadOrRequest} from "../../utils";
import {
    customerActiveError,
    customerActiveSuccess,
    customerCreateError,
    customerCreateSuccess,
    customerLoadError,
    customerLoadSuccess,
    customersGetError,
    customersGetSuccess,
    customerUpdateError,
    customerUpdateSuccess,
} from "./actions";
import * as TYPES from "./types";

export default function* customersSagas() {
    yield takeEvery(TYPES.CUSTOMERS_GET_REQUEST, customersGetRequest);
    yield takeEvery(TYPES.CUSTOMER_LOAD_REQUEST, customerLoadRequest);
    yield takeEvery(TYPES.CUSTOMER_CREATE_REQUEST, customerCreateRequest);
    yield takeEvery(TYPES.CUSTOMER_UPDATE_REQUEST, customerUpdateRequest);
    yield takeLatest(TYPES.ACTIVE_REQUEST, customerActiveRequest);
}

function* customersGetRequest(action) {
    try {
        const response = yield Customer.index({
            ...action.payload,
        });

        yield put(
            customersGetSuccess({
                ...fillItems(response, Customer),
                _params: action.payload,
            })
        );
    } catch (error) {
        yield put(customersGetError(error));
    }
}

function* customerLoadRequest(action) {
    try {
        const response = yield Customer.find(action.payload);

        yield put(
            customerLoadSuccess({
                ...response,
                _params: action.payload,
            })
        );
    } catch (error) {
        yield put(customerLoadError(error));
    }
}

function* customerCreateRequest(action) {
    try {
        const response = yield Customer.create();

        yield put(
            customerCreateSuccess({
                ...response,
                _params: action.payload,
            })
        );
    } catch (error) {
        yield put(customerCreateError(error));
    }
}

function* customerUpdateRequest({payload}) {
    try {
        const response = yield Customer.update(payload.id, payload);

        yield call(afterAction, payload);

        yield put(
            customerUpdateSuccess({
                ...response,
                _params: payload,
            })
        );
    } catch (error) {
        yield put(customerUpdateError(error));
    }
}

function* customerActiveRequest({payload}) {
    try {
        const response = yield loadOrRequest("Customers", payload.id, (id) => Customer.find(id, payload));
        yield put(customerActiveSuccess(response));
    } catch (err) {
        const {response} = err;
        console.error(err);

        yield put(customerActiveError(response));
    }
}
